import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-profile-dialog-2fa-change',
  templateUrl: './profile-dialog-2fa-change.component.html',
  styleUrls: ['./profile-dialog-2fa-change.component.scss'],
  standalone: false
})
export class ProfileDialog2FAChangeComponent {
  @Output() changeTwoFAModal = new EventEmitter<boolean>();
  @Output() openTwoFA = new EventEmitter<boolean>();

  close(): void {
    this.changeTwoFAModal.emit(false);
  }

  switchOn(): void {
    this.openTwoFA.emit(true);
    this.close();
  }
}
